import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// import './LoginPage.css';

const LoginPage = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.username || !form.password) {
      setError('Please enter both username and password.');
      return;
    }

    const response = await fetch('https://triunityiq.com/api.php/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
    });

    const data = await response.json();

    if (data.status === 1) {
      localStorage.setItem('user', JSON.stringify(data.user));
      navigate('/');
    } else {
      setError(data.msg);
    }
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <h2 className="login-title">Welcome to TriUnityIQ</h2>
        <p className="login-subtitle">Secure Login Portal</p>
        {error && <p className="login-error">{error}</p>}
        <form className="login-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="username"
            placeholder="Enter your username"
            value={form.username}
            onChange={handleChange}
          />
          <input
            type="password"
            name="password"
            placeholder="Enter your password"
            value={form.password}
            onChange={handleChange}
          />
          <button type="submit" className="login-button">Login</button>
        </form>
        <p className="login-footer">
          © {new Date().getFullYear()} TriUnityIQ. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
